import { formatStamp, mergeTimeline } from "../../lib/complaints";
import { LBL } from "../msd/ui";

function MessageEntry({ entry }) {
  const isCustomer = entry.senderRole === "customer";
  return (
    <li className="text-[14px]">
      <span className={LBL}>
        <span className="font-semibold text-msd-ink2">{isCustomer ? "Customer" : "Staff"}</span>
        {" · "}
        {formatStamp(entry.at)}
      </span>
      {entry.text && (
        <div className="line-clamp-3" title={entry.text}>
          "{entry.text}"
        </div>
      )}
    </li>
  );
}

// Dashboard/system moves with no linked message (a manager clicking "Start
// work" from the desk, auto-close, etc.) aren't part of the WhatsApp
// conversation -- the tracker above already shows the current stage, so
// only real messages belong in this timeline.
export default function ComplaintTimeline({ complaint }) {
  const entries = mergeTimeline(complaint.history, complaint.messages).filter((e) => e.kind === "message");

  if (!entries.length) return <p className={`m-0 pl-[22px] ${LBL}`}>No messages recorded yet.</p>;

  return (
    <ol className="m-0 flex list-none flex-col gap-2 p-0 pl-[22px]" data-testid={`complaint-timeline-${complaint.complaint_no}`}>
      {entries.map((entry) => (
        <MessageEntry key={entry.key} entry={entry} />
      ))}
    </ol>
  );
}
